"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEndTimeFromYear = exports.createStartTimeFromYear = exports.createEndTimeFromMonth = exports.createStartTimeFromMonth = exports.getStartOfNextDay = exports.getCurrentDate = exports.getYearLocalStartDate = exports.getLastDayOfLastYear = exports.getFirstDayOfLastYear = exports.getLastDayOfCurrentYear = exports.getFirstDayOfCurrentYear = exports.getCurrentYear = exports.MAX_MONTHS_PERIOD = exports.ONE_YEAR_MS = exports.FOUR_WEEKS_MS = exports.ONE_MONTH_MS = exports.ONE_WEEK_MS = exports.ONE_DAY_MS = exports.ONE_HOUR_MS = exports.ONE_QUARTER_MS = exports.ONE_MINUTE_MS = exports.ONE_SECOND_MS = exports.WEEK = exports.DAY = exports.HOUR = exports.HALF_HOUR = exports.MINUTE = exports.SECOND = exports.ONE_MILLION = exports.ONE_THOUSAND = void 0;
const luxon_1 = require("luxon");
exports.ONE_THOUSAND = 1_000;
exports.ONE_MILLION = 1_000_000;
exports.SECOND = 1000;
exports.MINUTE = 60 * exports.SECOND;
exports.HALF_HOUR = 30 * exports.MINUTE;
exports.HOUR = 60 * exports.MINUTE;
exports.DAY = 24 * exports.HOUR;
exports.WEEK = 7 * exports.DAY;
exports.ONE_SECOND_MS = 1000;
exports.ONE_MINUTE_MS = 60 * exports.ONE_SECOND_MS;
exports.ONE_QUARTER_MS = 15 * exports.ONE_MINUTE_MS;
exports.ONE_HOUR_MS = 60 * exports.ONE_MINUTE_MS;
exports.ONE_DAY_MS = 24 * exports.ONE_HOUR_MS;
exports.ONE_WEEK_MS = 7 * exports.ONE_DAY_MS;
exports.ONE_MONTH_MS = 30 * exports.ONE_DAY_MS;
exports.FOUR_WEEKS_MS = 4 * exports.ONE_WEEK_MS;
exports.ONE_YEAR_MS = 365 * exports.ONE_DAY_MS;
exports.MAX_MONTHS_PERIOD = 12;
const getCurrentYear = () => new Date().getFullYear();
exports.getCurrentYear = getCurrentYear;
const firstMonthOfTheYear = 0;
const lastMonthOfTheYear = 11;
const firstDayOfJanuary = 1;
const lastDayOfDecember = 31;
const getFirstDayOfCurrentYear = () => new Date((0, exports.getCurrentYear)(), firstMonthOfTheYear, firstDayOfJanuary, 0, 0, 0, 0);
exports.getFirstDayOfCurrentYear = getFirstDayOfCurrentYear;
const getLastDayOfCurrentYear = () => new Date((0, exports.getCurrentYear)(), lastMonthOfTheYear, lastDayOfDecember, 0, 0, 0, 0);
exports.getLastDayOfCurrentYear = getLastDayOfCurrentYear;
const getFirstDayOfLastYear = () => new Date((0, exports.getCurrentYear)() - 1, firstMonthOfTheYear, firstDayOfJanuary, 0, 0, 0, 0);
exports.getFirstDayOfLastYear = getFirstDayOfLastYear;
const getLastDayOfLastYear = () => new Date((0, exports.getCurrentYear)() - 1, lastMonthOfTheYear, lastDayOfDecember, 0, 0, 0, 0);
exports.getLastDayOfLastYear = getLastDayOfLastYear;
const getYearLocalStartDate = (year) => new Date(year, firstMonthOfTheYear, firstDayOfJanuary, 0, 0, 0, 0);
exports.getYearLocalStartDate = getYearLocalStartDate;
const getCurrentDate = () => new Date();
exports.getCurrentDate = getCurrentDate;
const getStartOfNextDay = () => {
    const date = new Date();
    date.setUTCDate(date.getUTCDate() + 1);
    date.setUTCHours(0, 0, 0, 0);
    return date;
};
exports.getStartOfNextDay = getStartOfNextDay;
const createStartTimeFromMonth = (year, month) => {
    return luxon_1.DateTime.utc(year, month, 1, 0, 0).toJSDate();
};
exports.createStartTimeFromMonth = createStartTimeFromMonth;
const createEndTimeFromMonth = (year, month) => {
    const nextMonth = luxon_1.DateTime.utc(year, month, 1).plus({ months: 1 });
    return luxon_1.DateTime.utc(nextMonth.year, nextMonth.month, 1, 0, 0).toJSDate();
};
exports.createEndTimeFromMonth = createEndTimeFromMonth;
const createStartTimeFromYear = (year) => new Date(Date.UTC(year, firstMonthOfTheYear, firstDayOfJanuary, 0, 0, 0, 0));
exports.createStartTimeFromYear = createStartTimeFromYear;
const createEndTimeFromYear = (year) => new Date(Date.UTC(year + 1, firstMonthOfTheYear, firstDayOfJanuary, 0, 0, 0, 0));
exports.createEndTimeFromYear = createEndTimeFromYear;
//# sourceMappingURL=constants.js.map